/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbToastrModule,
  NbToggleModule,
  NbWindowModule,
} from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { NbAlertModule, NbInputModule, NbCheckboxModule, NbButtonModule } from '@nebular/theme';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import { NbCardModule } from '@nebular/theme';
import { ConfirmDialogComponent } from './pages/tables/smart-table-codes-postaux/confirm-dialog.component';
import { BooleanColumnComponent } from './pages/tables/smart-table-codes-postaux/boolean-column.component';
import { ConfirmDialogSuppressionChauffeurComponent } from './pages/tables/smart-table/confirm-dialog-suppression.component';
import { ErrorDialogComponent } from './pages/tables/smart-table/error-dialog.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { EchartsRendezvousBarComponent } from './pages/statistiques/echarts-rendezvous-bar-component';
import { EchartsDashboardComponent } from './pages/statistiques/echarts-dashboard.component';
import { EchartsRendezvousLineComponent } from './pages/statistiques/echarts-dashboard-line-component';
import { DonateurChartComponent } from './pages/statistiques/echarts-donateurs-cards-component';
import { MonthlyWeightChartComponent } from './pages/statistiques/echarts-monthly-weight-collected-component';
import { RendezvousCardComponent } from './pages/statistiques/echarts-rendezvous-cards-component';
import { DaysWithMostCollectionsChartComponent } from './pages/statistiques/echarts-dashboard-daywithmostcollections-card-component';
import { AverageWeightCollectedChartComponent } from './pages/statistiques/echarts-dashboard-averageweightcollected-card-component';
import { DailyCollectionsChartComponent } from './pages/statistiques/echarts-dashboard-daily-collections-by-month-component';

import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NbIconModule } from '@nebular/theme';





@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfirmDialogComponent,
    BooleanColumnComponent,
    ConfirmDialogSuppressionChauffeurComponent,
    ErrorDialogComponent,
    EchartsRendezvousBarComponent,
    EchartsRendezvousLineComponent,
    EchartsDashboardComponent,
    DonateurChartComponent,
    MonthlyWeightChartComponent,
    RendezvousCardComponent,
    DaysWithMostCollectionsChartComponent,
    AverageWeightCollectedChartComponent,
    DailyCollectionsChartComponent,
  ],
  imports: [
    MatSelectModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    FormsModule, // Pour utiliser ngModel et ngForm
    NbAlertModule,
    NbInputModule,
    NbCheckboxModule,
    NbButtonModule,
    NbCardModule,
    NbToggleModule,
    NgxEchartsModule,
    NbSpinnerModule,
    MatDialogModule,
    MatPaginatorModule,
    MatTooltipModule,
    NbIconModule
  ],
  bootstrap: [AppComponent],
  
})
export class AppModule {
}
